module.exports = __webpack_public_path__ + "img/artificers_h.066756ef.png";